import PropTypes from 'prop-types';

import FundingMatchCardRow from 'modules/MatchesNav/components/FundingMatchCardRow/FundingMatchCardRow';
import ShareableReportSectionCell from 'modules/ShareableReport/components/ShareableReportSectionCell/ShareableReportSectionCell';
import ShareableReportSectionCellsColumn from 'modules/ShareableReport/components/ShareableReportSectionCellsColumn/ShareableReportSectionCellsColumn';

const ShareableReportSummaryColumn = ({
  isHidden,
  noBorder,
  isDraggable,
  isDroppable,
  productRequiredFields = [],
}) => {
  const valuesFirstFields = productRequiredFields.sort((current, next) => {
    if (current.config?.title && !next.config?.title) {
      return -1;
    }

    return 1;
  });

  return (
    <ShareableReportSectionCellsColumn
      hidden={isHidden}
      noBorder={noBorder}
      isDraggable={isDraggable}
      isDroppable={isDroppable}
    >
      {valuesFirstFields.map((field, index) => (
        <ShareableReportSectionCell key={index} noBorder={noBorder} className="u-flex-align-center">
          <FundingMatchCardRow
            config={field.config}
            propertyName={field?.key}
            value={field.optionValue}
          />
        </ShareableReportSectionCell>
      ))}
    </ShareableReportSectionCellsColumn>
  );
};

ShareableReportSummaryColumn.propTypes = {
  noBorder: PropTypes.bool,
  isHidden: PropTypes.bool,
  isDraggable: PropTypes.bool,
  isDroppable: PropTypes.bool,
  productRequiredFields: PropTypes.array,
};

export default ShareableReportSummaryColumn;
